export function centsToValue(number: number, precision: number) {
  return number / Math.pow(10, precision);
}

export function valueToCents(number: number, precision: number) {
  return number * Math.pow(10, precision);
}
